import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  getEmployees,
  deleteEmployee,
  activateEmployee,
  deactivateEmployee,
} from "../actions/employeeActions";

import { Grid, Switch, FormControlLabel, Button } from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";

class EmployeeList extends Component {
  state = {
    isActive: true,
    employees: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  deleteEmployee(employeeEmail) {
    this.props.deleteEmployee(employeeEmail).then(() => {
      this.setState({
        employees: this.state.employees.filter((g) => g.email != employeeEmail),
      });
    });
  }

  activateEmployee(employeeEmail) {
    this.props.activateEmployee(employeeEmail).then(() => {
      this.setState({
        employees: this.state.employees.filter((g) => g.email != employeeEmail),
      });
    });
  }

  deactivateEmployee(employeeEmail) {
    this.props.deactivateEmployee(employeeEmail).then(() => {
      this.setState({
        employees: this.state.employees.filter((g) => g.email != employeeEmail),
      });
    });
  }

  refreshData = () => {
    this.setState({ employees: [] });

    this.props
      .getEmployees({ isActive: this.state.isActive })
      .then((employees) => {
        this.setState({ employees });
      });
  };

  handleSwitchChange = (e) =>
    this.setState({ [e.target.name]: e.target.checked });

  render() {
    return (
      <Fragment>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  id="isActive"
                  name="isActive"
                  checked={this.state.isActive}
                  onChange={this.handleSwitchChange}
                  color="primary"
                />
              }
              label="Actieve medewerkers"
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.refreshData}
          >
            Zoek
          </Button>
        </Grid>

        <DataListWithSearchFilter
          data={this.state.employees.map((employee) => {
            return {
              id: employee.email,
              avatar: new Buffer(employee.facePhoto, "base64").toString(
                "binary",
              ),
              title: `${employee.firstName} ${employee.lastName}`,
              subtitle: employee.email,
              onClick: () =>
                (window.location.href = `/employee/${employee.email}`),
              ctxMenu: [
                {
                  label: employee.isActive ? "De-activeren" : "Activeren",
                  action: () =>
                    employee.isActive
                      ? this.deactivateEmployee(employee.email)
                      : this.activateEmployee(employee.email),
                  confirm: true,
                },
                {
                  label: "Wijzigen",
                  action: () =>
                    (window.location.href = `/employee/${employee.email}/update`),
                },
                {
                  label: "Verwijderen",
                  action: () => this.deleteEmployee(employee.email),
                  confirm: true,
                },
              ],
            };
          })}
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        />
      </Fragment>
    );
  }
}

EmployeeList.propTypes = {
  getEmployees: PropTypes.func.isRequired,
  deleteEmployee: PropTypes.func.isRequired,
  activateEmployee: PropTypes.func.isRequired,
  deactivateEmployee: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage:
    state.employee.deleteEmployee.successMessage ||
    state.employee.activateEmployee.successMessage ||
    state.employee.deactivateEmployee.successMessage,
  errorMessage:
    state.employee.deleteEmployee.errorMessage ||
    state.employee.activateEmployee.errorMessage ||
    state.employee.deactivateEmployee.errorMessage,
  isFetching:
    state.employee.deleteEmployee.isFetching ||
    state.employee.activateEmployee.isFetching ||
    state.employee.deactivateEmployee.isFetching ||
    state.employee.getEmployees.isFetching,
});

export default connect(mapStateToProps, {
  getEmployees,
  deleteEmployee,
  activateEmployee,
  deactivateEmployee,
})(EmployeeList);



// WEBPACK FOOTER //
// ./src/components/EmployeeList.js